/**
 * Local Formik error helpers for service agreements (§6).
 * Keep on agreements branch — do not move into Utils / operationFeedback.
 */

export function flattenFormikErrorEntries(errors, prefix = "") {
  if (!errors || typeof errors !== "object") return [];
  const out = [];
  Object.entries(errors).forEach(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (value == null) return;
    if (typeof value === "string") {
      out.push({ name: path, message: value });
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (typeof item === "string") {
          out.push({ name: `${path}[${index}]`, message: item });
        } else if (item && typeof item === "object") {
          out.push(...flattenFormikErrorEntries(item, `${path}[${index}]`));
        }
      });
      return;
    }
    if (typeof value === "object") {
      out.push(...flattenFormikErrorEntries(value, path));
    }
  });
  return out;
}

/**
 * Focus first matching field by name attribute. Returns focused name or null.
 */
export function focusFirstFormikError(errors, root) {
  const entries = flattenFormikErrorEntries(errors);
  const scope = root || document;
  for (const { name } of entries) {
    if (!name || name === "submit") continue;
    const safeName =
      typeof CSS !== "undefined" && CSS.escape
        ? CSS.escape(name)
        : name.replace(/"/g, '\\"');
    const el =
      scope.querySelector?.(`[name="${safeName}"]`) ||
      scope.querySelector?.(`[name="${name}"]`);
    if (el && typeof el.focus === "function") {
      try {
        el.focus({ preventScroll: false });
      } catch {
        el.focus();
      }
      if (typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return name;
    }
  }
  return null;
}
